import {
  createContext,
  useState,
  useMemo,
  useEffect,
  useCallback,
} from "react";
import {
  getAllGroups as apiGetAllGroups,
  createGroup as apiCreateGroup,
  deleteGroup as apiDeleteGroup,
  editGroup as apiEditGroup,
  getAllUsers as apiGetAllUsers,
} from "../api";

import { useCurrentUser } from "../auth/auth";

export const GroupContext = createContext();

export const GroupContextProvider = ({ children }) => {
  const [globalData, setGlobalData] = useState({
    allGroups: [],
    memberUsers: [],
    adminUsers: [],
  });
  const { data: currentUser } = useCurrentUser();

  const filterUsers = (allUsers) => {
    const memberUsers = [];
    const adminUsers = [];
    allUsers.forEach((user) => {
      if (user.role === 1) adminUsers.push(user);
      else memberUsers.push(user);
    });

    return { adminUsers, memberUsers };
  };

  const getAllGroups = useCallback(() => {
    apiGetAllGroups((newGroups) =>
      setGlobalData((prev) => {
        return {
          allGroups: newGroups,
          memberUsers: prev.memberUsers,
          adminUsers: prev.adminUsers,
        };
      })
    );
  }, []);
  const createGroup = useCallback(async (group) => {
    const res = await apiCreateGroup(group);
    getLatestData();
    return res;
  }, []);

  const deleteGroup = useCallback(async (groupId) => {
    const res = await apiDeleteGroup(groupId);
    getLatestData();
    return res;
  }, []);

  const editGroup = useCallback(async (group) => {
    const res = await apiEditGroup(group);
    getLatestData();
    return res;
  }, []);

  const getAllUsers = useCallback(() => {
    apiGetAllUsers((newUsers) => {
      const { memberUsers, adminUsers } = filterUsers(newUsers);
      setGlobalData((prev) => {
        return {
          allGroups: prev.allGroups,
          memberUsers,
          adminUsers,
        };
      });
    });
  }, []);

  const getLatestData = useCallback(() => {
    getAllGroups();
    getAllUsers();
  }, [getAllGroups, getAllUsers]);

  // Initalize allGroups, and allUsers if current user is admin.
  useEffect(() => {
    getAllGroups();
    if (currentUser.role === 1) {
      getAllUsers();
    }
  }, []);

  const value = useMemo(
    () => ({
      getAllGroups,
      createGroup,
      deleteGroup,
      editGroup,
      getAllUsers,
      globalData,
      getLatestData,
    }),
    [
      getAllUsers,
      getAllGroups,
      createGroup,
      deleteGroup,
      editGroup,
      globalData,
      getLatestData,
    ]
  );

  return (
    <GroupContext.Provider value={value}>{children}</GroupContext.Provider>
  );
};
